'use client';

import { cn } from '@/lib/utils';
import React, { InputHTMLAttributes, forwardRef } from 'react';
import { FieldError, UseFormRegister } from 'react-hook-form';

interface CustomInputProps extends InputHTMLAttributes<HTMLInputElement> {
    required?: boolean;
    className?: string;
    register?: UseFormRegister<any>;
    error?: FieldError | string;
    color?: 'white' | 'black';
}

const Input = forwardRef<HTMLInputElement, CustomInputProps>((props, ref) => {
    const { className, required, type, register, error, color = 'black', ...inputProps } = props;

    return (
        <div className="flex flex-col">
            <input
                {...register}
                {...inputProps}
                ref={ref}
                type={type}
                className={cn(
                    'h-[72px] w-full border py-5 px-6 lg:text-h5 max-lg:text-h6 font-bold text-black placeholder-gray-300/50 focus:border-border-gray-300 focus:outline-none border-gray-300 placeholder-shown:border-gray-300 bg-transparent rounded-none uppercase leading-none',
                    error && 'border-red',
                    color === 'white' &&
                        'font-normal text-white placeholder-white/50 focus:border-border-white focus:outline-none border-white placeholder-shown:border-white',
                    className,
                )}
                placeholder={required ? `${inputProps.placeholder}*` : inputProps.placeholder}
                required={required}
            />
        </div>
    );
});

Input.displayName = 'Input';

export default Input;
